import { Directive, EventEmitter, HostListener, inject, Injector, Output } from '@angular/core';
import { ClickCounterService } from './click-counter.service';

/**
 * Directive to count clicks on an element. The counter is incremented each time the element is clicked,
 * and the current count is emitted through an output event.
 *
 * The `ClickCounterDirective` uses the `ClickCounterService` to manage the click count. So, the
 * total number of clicks can be tracked across multiple instances of this directive if the
 * service is provided in a parent component.
 *
 * If the service is not provided in a parent component, it will create a new instance of the service.
 * On that case, the counter will be one per instance of the directive.
 *
 */
@Directive({
  standalone: true,
  selector: '[lxClickCounter]',
})
export class ClickCounterDirective {
  @Output() clickCount = new EventEmitter<number>();

  private readonly clickCounterService = inject(Injector).get(ClickCounterService, new ClickCounterService());

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    this.clickCounterService.incrementCounter();
    this.clickCount.emit(this.clickCounterService.getCounter());
    event.stopImmediatePropagation();
  }
}
